<div class="flex-layout">
  <app-branding></app-branding>
  <mat-nav-list class="sidebar-list" style="color: white;" >
    <app-nav-item *ngFor="let item of navItems" [item]="item"> </app-nav-item>
  </mat-nav-list>
  <div class="p-24 m-t-auto">
   
  </div>
</div>
<style>
 
/* ::ng-deep .sidebar-list::-webkit-scrollbar {
  display: none;
}


::ng-deep .sidebar-list {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

::ng-deep .sidebar-list {
  overflow:hidden;
} */

</style>